import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["case"]
  static values = {
    initialCase: String
  }

  connect() {
    this.updateCaseVisibility(this.initialCaseValue)
  }

  /**
   * Extracts the selected case name from the event target value.
   * @param {Event} event - The event object from which to extract the case name.
   * @returns {string} The extracted case name.
   */
  extractCaseNameFromEvent(event) {
    return event.target.value
  }

  /**
   * Updates the visibility of case elements based on the provided case name.
   * Case elements with a matching case name are shown, others are hidden.
   * @param {string} caseName - The name of the case to display.
   */
  updateCaseVisibility(caseName) {
    const name = caseName ? caseName.trim() : ""
    this.caseTargets.forEach(element => {
      if (element.dataset.caseName.split(/\s*,\s*/).indexOf(name) >= 0) {
        element.classList.remove('hidden')
      } else {
        element.classList.add('hidden')
      }
    })
  }

  /**
   * Event handler for updating the visibility of case elements.
   * Extracts the case name from the event and updates the visibility accordingly.
   * @param {Event} event - The event that triggered the update.
   */
  update(event) {
    this.updateCaseVisibility(this.extractCaseNameFromEvent(event))
  }
}
